(function() {
    'use strict';

    angular
        .module('liverunApp')
        .controller('SocialMediaDialogController', SocialMediaDialogController);

    SocialMediaDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SocialMedia', 'Runner', 'Trainer'];

    function SocialMediaDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SocialMedia, Runner, Trainer) {
        var vm = this;

        vm.socialMedia = entity;
        vm.clear = clear;
        vm.save = save;
        vm.runners = Runner.query();
        vm.trainers = Trainer.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.socialMedia.id !== null) {
                SocialMedia.update(vm.socialMedia, onSaveSuccess, onSaveError);
            } else {
                SocialMedia.save(vm.socialMedia, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('liverunApp:socialMediaUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
